import React from 'react';
import { useParams, Link } from 'react-router-dom';
import DashboardSidebar from '../components/DashboardSidebar';
import BottomNav from '../components/BottomNav';
import '../styles/Dashboard.css';

function Renew() {
  const { userId } = useParams();

  return (
    <div className="dashboard-page has-bottom-nav">
      <DashboardSidebar userId={userId} user={null} />
      <div className="dashboard-main">
        <div className="dashboard-header">
          <h1 className="dashboard-greeting">Renew Subscription</h1>
        </div>
        <div className="settings-content">
          <div className="dashboard-card">
            <h3>Re-subscription Coming Soon</h3>
            <p style={{ marginTop: '16px', lineHeight: 1.6 }}>
              When your yearly membership expires, you'll be able to renew and choose whether to stay with your club or continue solo.
            </p>
            <Link to={`/${userId}/dashboard`} className="c-ripple primary-button" style={{ display: 'inline-block', marginTop: '24px' }}>
              Back to Dashboard
            </Link>
          </div>
        </div>
      </div>
      <BottomNav userId={userId} user={null} />
    </div>
  );
}

export default Renew;
